<template>
  <span id="update-all-shippers-cutoff-group-section" v-if="this.$can(this.permissions.WAREHOUSE.EDIT_SHIPPERS) && this.$can(this.permissions.WAREHOUSE.BULK_EDIT_SHIPPER_CUTOFF_GROUP)">
    <el-button
      id="btn-update-all-shippers-cutoff-group"
      type="success"
      size="mini"
      plain
      v-show="shipperPage.total > 0"
      @click="dialogVisible = true"
    >{{ $t('shipper.updateAllCutoffGroup') }}</el-button>
    <el-dialog
      width="30%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      :title="$t('shipper.updateCutoffGroup')"
      :visible.sync="dialogVisible"
      @open="handleOpen()"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row class="shipper-cutoff-group-warning">
          <el-col :span="24">
            <span v-html="$t('shipper.updateCutoffGroupWarning').replace('[numberOfShippers]', shipperPage.total)"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="form-vertical-item">
            <el-form-item :label="$t('shipper.cutoffGroup')" prop="shipperCutoffGroupId">
              <shipper-cutoff-group
                ref="shipperCutoffGroupSelect"
                :value.sync="form.shipperCutoffGroupId"
                :includeOptionAll="false"
                :includeOptionNone="true" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="update-all-shippers-cutoff-group-dialog-footer" class="dialog-footer form-vertical-item flex-reverse-direction" slot="footer">
        <el-button
          id="form-save-button"
          type="primary"
          size="mini"
          @click="submitForm()"
        >{{ $t('common.updateAll') }}</el-button>
        <el-button id="form-cancel-button" size="mini" @click="resetForm()">{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import ShipperCutoffGroup from '@/views/warehouse/shippers/components/ShipperCutoffGroup';

export default {
  name: 'ShipperCutoffGroupBulkUpdate',
  components: { ShipperCutoffGroup },
  computed: {
    ...mapGetters([
      'shipperPage'
    ])
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        shipperCutoffGroupId: null
      },
      formRules: {
        shipperCutoffGroupId: [
          { required: true, message: this.$t('shipper.error.shipperCutoffGroupRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          try {
            const response = await this.$store.dispatch('account/shipperCutoffGroupBulkUpdate', this.form.shipperCutoffGroupId);
            this.$message.success(response.message);
            this.resetForm();
            this.$store.dispatch('account/searchShippers', {});
          } finally {
            loading.close();
          }
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.shipperCutoffGroupId = null;
      this.$refs.shipperCutoffGroupSelect.setSelectedShipperCutoffGroup(this.form.shipperCutoffGroupId);
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  .shipper-cutoff-group-warning {
    margin-bottom: 20px;
  }
</style>
